export const capitalizeWords = (value: string) => {
    return value.replace(/\w\S*/g, (txt) => {
        return capitalizeWord(txt);
    });
};

export const capitalizeWord = (value: string) => `${value.charAt(0).toUpperCase()}${value.substring(1).toLowerCase()}`;